// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimInternalNoteRequestDto
 */
export interface IClaimInternalNoteRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimInternalNoteRequestDto
     */
    claim_id: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInternalNoteRequestDto
     */
    note_text?: string;
}

/**
 * Check if a given object implements the IClaimInternalNoteRequestDto interface.
 */
export function instanceOfIClaimInternalNoteRequestDto(value: object): value is IClaimInternalNoteRequestDto {
    if (!('claim_id' in value) || value['claim_id'] === undefined) return false;
    return true;
}

export function IClaimInternalNoteRequestDtoFromJSON(json: any): IClaimInternalNoteRequestDto {
    return IClaimInternalNoteRequestDtoFromJSONTyped(json, false);
}

export function IClaimInternalNoteRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimInternalNoteRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'],
        'note_text': json['note_text'] == null ? undefined : json['note_text'],
    };
}

export function IClaimInternalNoteRequestDtoToJSON(json: any): IClaimInternalNoteRequestDto {
    return IClaimInternalNoteRequestDtoToJSONTyped(json, false);
}

export function IClaimInternalNoteRequestDtoToJSONTyped(value?: IClaimInternalNoteRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'note_text': value['note_text'],
    };
}

